import { render, staticRenderFns } from "./SpectrumNewEdit.vue?vue&type=template&id=5e0c20d8&scoped=true"
import script from "./SpectrumNewEdit.vue?vue&type=script&lang=js"
export * from "./SpectrumNewEdit.vue?vue&type=script&lang=js"
import style0 from "./SpectrumNewEdit.vue?vue&type=style&index=0&id=5e0c20d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c20d8",
  null
  
)

export default component.exports